import { Link } from "react-router-dom";
import useLang from "hooks/useLang";
import React, { useEffect, useState, useCallback } from "react";
import { useAdminClient } from "hooks/useAdminClient";

const PopularPost = () => {
  const client = useAdminClient();
  const { lang } = useLang();
  const [articles, setArticles] = useState([])
    const fetchData = useCallback(async (params)  => {
        const queryParams = new URLSearchParams();
        queryParams.set('limit', 6)
        queryParams.set('order', 'DESC')
        const response = await client.get(`/be/api/v1/front-end/articles/getList?${queryParams}`);
        const {articles: data} = response.data;
        setArticles(data);
      }, [])
      useEffect(() => {
        fetchData();
      }, [fetchData])
  return (
    <React.Fragment>
      <div className="mt-4 pt-2">
        <div className="sd-title">
          <h6 className="fs-16 mb-3">{lang.others.popular_post}</h6>
        </div>
        <ul className="widget-popular-post list-unstyled my-4">
          {articles.map((popularPostDetails, key) => (
            <li
              className="d-flex mb-3 align-items-center pb-3 border-bottom"
              key={key}
            >
              <img
                src={`${process.env.REACT_APP_API_HOST}${popularPostDetails.cardImage}`}
                alt=""
                className="widget-popular-post-img rounded"
              />
              <div className="flex-grow-1 text-truncate ms-3">
              <Link to={`/tax-updates/detail?id=${popularPostDetails.id}`}>
                  {popularPostDetails.cardTitle}
                </Link>
                <span className="d-block text-muted fs-14">
                  {popularPostDetails.date}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </React.Fragment>
  );
};

export default PopularPost;
